import React, { useState, useContext } from 'react';
import Modal from '../Modal/Modal';
import { Award } from 'react-feather';
import styles from './WinBanner.module.css';
import { LanguageContext } from '../App';
import localisation from '../../localisation.json';

function WinBanner({ children }) {
    const [isOpen, setIsOpen] = useState(true);
    const { language } = useContext(LanguageContext);

    return (
        <div className={styles.animatedMmodal}>
            <Modal
                withDelay
                isOpen={isOpen}
                title={
                    <div className={styles.title}>
                        {localisation[0].winBanner.header[language]}{' '}
                        <Award size={24} color='gold' />
                    </div>
                }
                handleDismiss={() => setIsOpen(false)}>
                <div className={styles.actions}>{children}</div>
            </Modal>
        </div>
    );
}

export default WinBanner;
